export const colors = {
  red: "#c8102e",
  vermilion: "#f36b2c",
  gold: "#ffd166",
  deepGold: "#ffdf70",
  ivory: "#fff8e7",
  goldGlow: "rgba(255, 209, 102, 0.48)",
  darkText: "#8a1538",
};

export const pageShellSx = {
  minHeight: "100vh",
  position: "relative",
  overflow: "hidden",
  background: `
    radial-gradient(circle at 50% 14%, rgba(255, 230, 156, 0.52) 0%, rgba(255, 209, 102, 0.2) 24%, transparent 52%),
    radial-gradient(circle at 18% 26%, rgba(255, 215, 120, 0.28) 0%, transparent 30%),
    radial-gradient(circle at 82% 24%, rgba(255, 215, 120, 0.26) 0%, transparent 26%),
    linear-gradient(180deg, #b30f2a 0%, #d91f3f 34%, #ef5a2f 70%, #d79b2d 100%)
  `,
  color: "#fff8e7",
};

export const festiveCardSx = {
  position: "relative",
  overflow: "hidden",
  background:
    "linear-gradient(180deg, rgba(207, 29, 58, 0.94) 0%, rgba(166, 18, 45, 0.92) 100%)",
  borderRadius: 5,
  border: "1px solid rgba(255, 225, 141, 0.54)",
  boxShadow: "0 28px 70px rgba(137, 28, 20, 0.24)",
  backdropFilter: "blur(8px)",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(135deg, rgba(255, 239, 187, 0.24), transparent 24%, transparent 76%, rgba(255, 209, 102, 0.22))",
    pointerEvents: "none",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 12,
    borderRadius: 4,
    border: "1px solid rgba(255, 248, 231, 0.18)",
    pointerEvents: "none",
  },
};

export const gradientBtnSx = {
  background: `linear-gradient(135deg, #ffe49a 0%, #ffd166 40%, #ffdf70 100%)`,
  color: "#8a1538",
  fontWeight: 800,
  letterSpacing: "0.04em",
  boxShadow:
    "0 14px 30px rgba(172, 88, 18, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.45)",
  animation: "festivePulse 2.4s ease-in-out infinite",
  "&:hover": {
    background: `linear-gradient(135deg, #fff0b8 0%, #ffd166 48%, #ffe16a 100%)`,
    boxShadow:
      "0 18px 36px rgba(172, 88, 18, 0.3), 0 0 30px rgba(255, 223, 112, 0.5)",
    transform: "translateY(-2px)",
  },
  "&.Mui-disabled": {
    color: "rgba(138, 21, 56, 0.68)",
    background:
      "linear-gradient(135deg, rgba(255, 228, 154, 0.72), rgba(255, 209, 102, 0.68))",
  },
  transition:
    "transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease",
};
